import {isBannerShow} from "@helpers";
import {store} from 'index.js';

export const getSidebarStyles = (theme, drawerWidth) => {
    var plan = store.getState().plan;
    var user = store.getState().user;
    var account = store.getState().account;
    const h = isBannerShow(plan ?? account, user) ? 20 : 25;
    return {
        drawer: {
            width: drawerWidth
        },
        paper: {
            overflow: 'hidden',
            zIndex: 2,
            boxShadow: '3px 0px 6px #00000029'
        },
        drawerOpen: {
            width: drawerWidth,
            position: "absolute",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            overflowY: 'auto',
            overflowX: 'hidden',
            height: `calc(100% - ${h}px)`,
        },
        drawerClose: {
            display: "flex",
            position: "absolute",
            flexDirection: "column",
            justifyContent: "space-between",
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            overflowY: 'auto',
            overflowX: 'hidden',
            height: `calc(100% - ${h}px)`,
            [theme.breakpoints.up('sm')]: {
                width: 90
            },
        },
        list: {
            marginTop: 0,
            paddingTop: 0,
            height: '100%'
        },
        listItemClose: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            transition: 'all 1s'
        },
        listItemOpen: {
            paddingLeft: '40px !important',
            transition: 'all 1s'
        },
        text: {
            textTransform: 'capitalize',
            fontSize: 15,
            marginLeft: 8
        },
        tooltip: {
            fontSize: 14
        }
    }
}
